export default __webpack_public_path__ + "static/media/green_up_arrow.28d3c66e.svg";